import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest, filter, take, timeout, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChartReadyService {
  private chartStates = new Map<string, BehaviorSubject<boolean>>();

  registerChart(chartId: string): void {
    if (!this.chartStates.has(chartId)) {
      console.log(`[ChartReady] Registering chart: ${chartId}`);
      this.chartStates.set(chartId, new BehaviorSubject<boolean>(false));
    }
  }

  markChartReady(chartId: string): void {
    console.log(`[ChartReady] Marking READY: ${chartId}`);
    const state = this.chartStates.get(chartId);
    if (state) {
      state.next(true);
    } else {
      console.warn(`[ChartReady] Chart not registered: ${chartId}`);
    }
  }

  markChartNotReady(chartId: string): void {
    console.log(`[ChartReady] Marking NOT READY: ${chartId}`);
    const state = this.chartStates.get(chartId);
    if (state) {
      state.next(false);
    }
  }

  isChartReady(chartId: string): boolean {
    const state = this.chartStates.get(chartId);
    return state ? state.getValue() : false;
  }

  waitForCharts(chartIds: string[], timeoutMs = 5000): Observable<boolean[]> {
    console.log(`[ChartReady] waitForCharts called for:`, chartIds);
    console.log(`[ChartReady] Current states:`, chartIds.map(id => ({
      id,
      registered: this.chartStates.has(id),
      ready: this.chartStates.get(id)?.getValue() ?? 'N/A'
    })));

    const observables = chartIds.map(id => {
      const state = this.chartStates.get(id);
      if (!state) {
        this.registerChart(id);
        return this.chartStates.get(id)!.asObservable();
      }
      return state.asObservable();
    });

    return combineLatest(observables).pipe(
      filter(states => {
        const allReady = states.every(ready => ready);
        console.log(`[ChartReady] Checking states:`, states, `All ready: ${allReady}`);
        return allReady;
      }),
      take(1),
      timeout(timeoutMs),
      catchError(() => {
        console.warn('[ChartReady] Timeout esperando charts, estados finales:', chartIds.map(id => ({
          id,
          ready: this.chartStates.get(id)?.getValue() ?? 'N/A'
        })));
        return of(chartIds.map(() => true));
      })
    );
  }

  reset(): void {
    this.chartStates.forEach(state => state.next(false));
  }

  clear(): void {
    this.chartStates.clear();
  }
}
